export const repair = {
  'fields': [
    {
        formType: 'tree-select',
        placeholder: '请选择',
        prop: 'abodeName',
        label: '站点名称',
        labelWidth: null,
        required: true,
        options:[],
        initValue: '',
        rules: [{
          type: 'string',
          required: true,
          message: '请选择站点',
          trigger: ['blur', 'change']
        }]
    },
    {
    formType: 'input',
    placeholder: '请输入',
    prop: 'name',
    label: '用户姓名',
    labelWidth: null,
    required: true,
    initValue: '',
    rules: [{
      type: 'string',
      required: true,
      message: '请输入',
      trigger: ['blur', 'change']
    }]
  }, {
    formType: 'input',
    placeholder: '请选择',
    prop: 'address',
    label: '报修区域',
    labelWidth: null,
    required: true,
    isAddress: true,
    initValue: '',
    rules: [{
      type: 'string',
      required: true,
      message: '请选择',
      trigger: ['blur', 'change']
    }]
  }, {
    formType: 'input',
    placeholder: '请输入',
    prop: 'addressDetail',
    label: '报修详细地址',
    labelWidth: null,
    required: true,
    initValue: '',
    rules: [{
      type: 'string',
      required: true,
      message: '请输入报修详细地址',
      trigger: ['blur', 'change']
    }]
  }, {
    formType: 'textarea',
    placeholder: '请输入报事报修内容',
    prop: 'explain',
    label: '报事报修内容',
    labelWidth: 200,
    labelPosition: 'top',
    initValue: '',
    required: false,
    rules: [{
      type: 'string',
      min: 3,
      required: false,
      message: '不低于3个字',
      trigger: ['change']
    }]
  },
  {
    formType: 'upload',
    placeholder: '',
    prop: 'images',
    label: '图片上传',
    fileName: 'file',
    maxCount: 5,
    multiple: true,
    accept: 'images',
    labelWidth: 200,
    labelPosition: 'top',
    initValue: [],
    required: true,
    rules: [{
      type: 'array',
      required: true,
      message: '请选择图片',
      trigger: ['change', 'blur']
    }]
  }
  ],
  'formRef': 'elForm',
  'formModel': 'formData',
  'size': 'medium',
  'labelPosition': 'right',
  'labelWidth': 120,
  'formRules': 'rules',
  'gutter': 15,
  'disabled': false,
  'span': 24,
  'formBtns': true
}

export const violations = {
  'fields': [
        {
        formType: 'tree-select',
        placeholder: '请选择',
        prop: 'abodeName',
        label: '站点名称',
        labelWidth: null,
        required: true,
        options:[],
        initValue: '',
        rules: [{
          type: 'string',
          required: true,
          message: '请选择站点',
          trigger: ['blur', 'change']
        }]
    },
    {
    formType: 'input',
    placeholder: '请输入',
    prop: 'name',
    label: '用户姓名',
    labelWidth: null,
    required: true,
    initValue: '',
    rules: [{
      type: 'string',
      required: true,
      message: '请输入',
      trigger: ['blur', 'change']
    }]
  }, {
    formType: 'input',
    placeholder: '请选择',
    prop: 'address',
    label: '违章举报区域',
    labelWidth: null,
    required: true,
    isAddress: true,
    initValue: '',
    rules: [{
      type: 'string',
      required: true,
      message: '请选择',
      trigger: ['blur', 'change']
    }]
  }, {
    formType: 'input',
    placeholder: '请输入',
    prop: 'addressDetail',
    label: '详细地址',
    labelWidth: null,
    required: true,
    initValue: '',
    rules: [{
      type: 'string',
      required: true,
      message: '请输入详细地址',
      trigger: ['blur', 'change']
    }]
  }, {
    formType: 'textarea',
    placeholder: '请输入违章举报内容',
    prop: 'explain',
    label: '违章举报内容',
    labelWidth: 200,
    labelPosition: 'top',
    initValue: '',
    required: false,
    rules: [{
      type: 'string',
      min: 3,
      required: false,
      message: '不低于3个字',
      trigger: ['change']
    }]
  },
  {
    formType: 'upload',
    placeholder: '',
    prop: 'images',
    label: '图片上传',
    fileName: 'file',
    maxCount: 5,
    multiple: true,
    accept: 'images',
    labelWidth: 200,
    labelPosition: 'top',
    initValue: [],
    required: true,
    rules: [{
      type: 'array',
      required: true,
      message: '请选择图片',
      trigger: ['change', 'blur']
    }]
  }
  ],
  'formRef': 'elForm',
  'formModel': 'formData',
  'size': 'medium',
  'labelPosition': 'right',
  'labelWidth': 100,
  'formRules': 'rules',
  'gutter': 15,
  'disabled': false,
  'span': 24,
  'formBtns': true
}
export const feedback = {
  'fields': [
        {
        formType: 'tree-select',
        placeholder: '请选择',
        prop: 'abodeName',
        label: '站点名称',
        labelWidth: null,
        required: true,
        options:[],
        initValue: '',
        rules: [{
          type: 'string',
          required: true,
          message: '请选择站点',
          trigger: ['blur', 'change']
        }]
    },
    {
    formType: 'input',
    placeholder: '请输入',
    prop: 'name',
    label: '用户姓名',
    labelWidth: null,
    required: true,
    initValue: '',
    rules: [{
      type: 'string',
      required: true,
      message: '请输入',
      trigger: ['blur', 'change']
    }]
  }, {
    formType: 'input',
    placeholder: '请选择',
    prop: 'address',
    label: '意见反馈区域',
    labelWidth: null,
    required: true,
    isAddress: true,
    initValue: '',
    rules: [{
      type: 'string',
      required: true,
      message: '请选择区域信息',
      trigger: ['blur', 'change']
    }]
  }, {
    formType: 'input',
    placeholder: '请输入',
    prop: 'addressDetail',
    label: '详细地址',
    labelWidth: null,
    required: true,
    initValue: '',
    rules: [{
      type: 'string',
      required: true,
      message: '请输入详细地址',
      trigger: ['blur', 'change']
    }]
  }, {
    formType: 'textarea',
    placeholder: '请输入意见反馈内容',
    prop: 'explain',
    label: '意见反馈内容',
    labelWidth: 200,
    labelPosition: 'top',
    initValue: '',
    required: false,
    rules: [{
      type: 'string',
      min: 3,
      required: false,
      message: '不低于3个字',
      trigger: ['change']
    }]
  },
  {
    formType: 'upload',
    placeholder: '',
    prop: 'images',
    label: '图片上传',
    fileName: 'file',
    maxCount: 5,
    multiple: true,
    accept: 'images',
    labelWidth: 200,
    labelPosition: 'top',
    initValue: [],
    required: true,
    rules: [{
      type: 'array',
      required: true,
      message: '请选择图片',
      trigger: ['change', 'blur']
    }]
  }
  ],
  'formRef': 'elForm',
  'formModel': 'formData',
  'size': 'medium',
  'labelPosition': 'right',
  'labelWidth': 100,
  'formRules': 'rules',
  'gutter': 15,
  'disabled': false,
  'span': 24,
  'formBtns': true
}

export const feedbackForm = {
  "size": "medium",
  "span": 24,
  "column": 2,
  "fields": [
    {
      "type": "default",
      "align": "top",
      "justify": "start",
      "__config__": {
        "span": 24,
        "formId": "kS8g673Gw",
        "layout": "rowFormItem",
        "tagIcon": "row",
        "children": [
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "标题",
              "formId": "kv4aucZJi",
              "layout": "colFormItem",
              "regList": [],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": false,
              "showItem": true,
              "changeTag": true,
              "renderKey": "kv4aucZJi1657787593808",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "field_kv4aucZJi",
            "placeholder": "请输入标题",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
          {
            "type": "textarea",
            "style": {
              "width": "100%"
            },
            "autosize": {
              "maxRows": 4,
              "minRows": 4
            },
            "disabled": false,
            "readonly": false,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "反映内容",
              "formId": "ki5I3KiGL",
              "layout": "colFormItem",
              "regList": [],
              "tagIcon": "textarea",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": true,
              "showItem": true,
              "changeTag": true,
              "renderKey": "ki5I3KiGL1637829415083",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "contentNotes",
            "placeholder": "请输入反映内容",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
         
        ],
        "document": "https://element.eleme.cn/#/zh-CN/component/layout#row-attributes",
        "renderKey": "kS8g673Gw1637829408011",
        "layoutTree": true,
        "componentName": "row_kS8g673Gw"
      }
    },
    {
      "type": "default",
      "align": "top",
      "justify": "start",
      "__config__": {
        "span": 24,
        "formId": "kQJOeFGvc",
        "layout": "rowFormItem",
        "tagIcon": "row",
        "children": [
          {
            "style": {},
            "disabled": false,
            "areaLabel": "小区",
            "areaValue": "areaInfor",
            "__config__": {
              "tag": "map-position",
              "span": 24,
              "label": "地址定位",
              "formId": "krkeLGZ58",
              "layout": "colFormItem",
              "regList": [],
              "tagIcon": "map-icon",
              "required": true,
              "showItem": true,
              "changeTag": true,
              "renderKey": "krkeLGZ581639037917612",
              "showLabel": false,
              "renderItem": true
            },
            "__vModel__": "address",
            "__readonly__": {
              "span": 2
            },
            "areaPlaceholder": "请选择小区信息",
            "fullPlaceholder": "请输入详细地址信息",
            "fullAddressLabel": "详细地址",
            "fullAddressValue": "fullAddressInfor"
          }
        ],
        "document": "https://element.eleme.cn/#/zh-CN/component/layout#row-attributes",
        "renderKey": "kQJOeFGvc1639037927413",
        "layoutTree": true,
        "componentName": "row_kQJOeFGvc"
      }
    },
    {
      "type": "default",
      "align": "top",
      "justify": "start",
      "__config__": {
        "span": 24,
        "formId": "kfFElXyqI",
        "layout": "rowFormItem",
        "tagIcon": "row",
        "children": [
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "联系人",
              "formId": "kAkw1aOHo",
              "layout": "colFormItem",
              "regList": [],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": true,
              "showItem": true,
              "changeTag": true,
              "renderKey": "kAkw1aOHo1637829853499",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "contacts",
            "placeholder": "请输入联系人",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "联系电话",
              "formId": "kRIHPorfb",
              "layout": "colFormItem",
              "regList": [
                {
                  "message": "请输入正确联系电话",
                  "pattern": "/^(0|86|17951)?(13[0-9]|15[012356789]|18[0-9]|14[57]|17[678])[0-9]{8}$/"
                }
              ],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": true,
              "showItem": true,
              "changeTag": true,
              "renderKey": "kRIHPorfb1637829871043",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "telephone",
            "placeholder": "请输入联系电话",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "身份证号",
              "formId": "kh1hMiV8G",
              "layout": "colFormItem",
              "regList": [
                {
                  "message": "请输入正确的身份证号",
                  "pattern": "/^[1-9]\\d{5}(?:18|19|20)\\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\\d|30|31)\\d{3}[\\dXx]$/"
                }
              ],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": false,
              "showItem": true,
              "changeTag": true,
              "renderKey": "kh1hMiV8G1666260426838",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "idNumber",
            "placeholder": "请输入身份证号",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
          {
            "name": "file",
            "accept": "",
            "__slot__": {
              "list-type": true
            },
            "disabled": false,
            "multiple": false,
            "list-type": "text",
            "__config__": {
              "tag": "el-upload",
              "_tag": "a-upload",
              "span": 24,
              "label": "图片上传",
              "formId": "kRXDldRDk",
              "layout": "colFormItem",
              "regList": [],
              "tagIcon": "upload",
              "document": "https://element.eleme.cn/#/zh-CN/component/upload",
              "fileSize": 5,
              "required": true,
              "showItem": true,
              "sizeUnit": "MB",
              "changeTag": true,
              "renderKey": "kRXDldRDk1637829774763",
              "showLabel": true,
              "buttonText": "点击上传",
              "renderItem": true
            },
            "__vModel__": "pictures",
            "buttonText": "",
            "auto-upload": true,
            "placeholder": "请附件上传图片上传",
            "__readonly__": {
              "span": 1
            },
            "uploadNumber": 2
          },
        ],
        "document": "https://element.eleme.cn/#/zh-CN/component/layout#row-attributes",
        "renderKey": "kfFElXyqI1637829847269",
        "layoutTree": true,
        "componentName": "row_kfFElXyqI"
      }
    },
    // {
    //   "type": "default",
    //   "align": "top",
    //   "justify": "start",
    //   "__config__": {
    //     "span": 24,
    //     "formId": "k1r2EjI30",
    //     "layout": "rowFormItem",
    //     "tagIcon": "row",
    //     "children": [
    //       {
    //         "size": "medium",
    //         "style": {},
    //         "__slot__": {
    //           "options": [
    //             {
    //               "label": "是",
    //               "value": 1
    //             },
    //             {
    //               "label": "否",
    //               "value": 2
    //             }
    //           ]
    //         },
    //         "disabled": false,
    //         "__config__": {
    //           "tag": "el-radio-group",
    //           "_tag": "a-radio-group",
    //           "span": 24,
    //           "label": "是否需要回复",
    //           "border": false,
    //           "formId": "k9oxo9m86",
    //           "layout": "colFormItem",
    //           "regList": [],
    //           "tagIcon": "radio",
    //           "dataType": "static",
    //           "document": "https://element.eleme.cn/#/zh-CN/component/radio",
    //           "required": true,
    //           "showItem": true,
    //           "changeTag": true,
    //           "renderKey": "k9oxo9m861637829926123",
    //           "showLabel": true,
    //           "optionType": "default",
    //           "renderItem": true,
    //           "defaultValue": 2
    //         },
    //         "__vModel__": "isReply",
    //         "__readonly__": {
    //           "span": 1
    //         }
    //       }
    //     ],
    //     "document": "https://element.eleme.cn/#/zh-CN/component/layout#row-attributes",
    //     "renderKey": "k1r2EjI301637829905994",
    //     "layoutTree": true,
    //     "componentName": "row_k1r2EjI30"
    //   }
    // }
  ],
  "gutter": 15,
  "formRef": "elForm",
  "disabled": false,
  "formBtns": true,
  "readonly": false,
  "formModel": "formData",
  "formRules": "rules",
  "labelWidth": 100,
  "labelPosition": "right"
}